import { distance2D } from '@paragon/utilities';

// This file contains functions related to working with mouse/touch event deltas. The configuration values were chosen
//   after careful and entirely non-subjective testing; feel free to alter but please test on a variety of devices.

const MAX_CLICK_DELTA = 7; // the maximum distance that can be covered for an event to sill be considered a click
const PINCH_DELTA_ADJUSTMENT_FACTOR = 2.6; // used to modify pinch delta to make it more usable

export function isDeltaWithinClickThreshold(delta: number) {
  return delta < MAX_CLICK_DELTA;
}

const getPinchDistance = (pointA: Touch, pointB: Touch): number =>
  distance2D(pointA.clientX, pointA.clientY, pointB.clientX, pointB.clientY);

export function getPinchDelta(previousPinch?: Touch[], currentPinch?: Touch[]): number | undefined {
  if (currentPinch === undefined || previousPinch === undefined) {
    return undefined;
  }

  if (currentPinch.length !== 2 || previousPinch.length !== 2) {
    throw new Error('Invalid pinch: should have exactly two touches');
  }

  const previousDistance = getPinchDistance(previousPinch[0], previousPinch[1]);
  const currentDistance = getPinchDistance(currentPinch[0], currentPinch[1]);
  const distanceDelta = previousDistance - currentDistance;

  return distanceDelta * PINCH_DELTA_ADJUSTMENT_FACTOR;
}
